import { RoutePath } from "#src/utils/route";
import { WorkflowTaskRoutePath } from "..";

export const WorkflowTaskDetailRoutePath = WorkflowTaskRoutePath.concat(
  new RoutePath<"taskId">({
    path: "/detail",
    title: "Workflow Task Details",
    isHidden: true,
  })
);
